import { AuthenticationRepository } from './repositories/authentication'
import { AuthenticationService } from './services/authentication'

const authenticationRepository = new AuthenticationRepository()

export const authenticationService = new AuthenticationService({
    authenticationRepository,
})
